export default __webpack_public_path__ + "static/media/480_store04-it-mobile.b2228db6.png";